import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/app-shell';
import { RequireSession } from './components/require-session';
import { AdminUserEditPage } from './pages/admin-user-edit';
import { AdminUserInvitePage } from './pages/admin-user-invite';
import { AdminUsersListPage } from './pages/admin-users';
import { AuditPage } from './pages/audit';
import { CaseDetailPage } from './pages/case-detail';
import { CaseRequestsPage } from './pages/case-requests';
import { CasesListPage } from './pages/cases';
import { DashboardPage } from './pages/dashboard';
import { IntegrationPage } from './pages/integration';
import { LoginPage } from './pages/login';
import { OrgConsentPage } from './pages/org-consent';
import { OrgEditPage } from './pages/org-edit';
import { OrgDetailPage } from './pages/org-detail';
import { OrgsListPage } from './pages/orgs';
import { PatientErasurePage } from './pages/patient-erasure';
import { PatientDetailPage } from './pages/patient-detail';
import { PatientsPage } from './pages/patients';
import { PlatformUserCreatePage } from './pages/platform-user-create';
import { PlatformUserEditPage } from './pages/platform-user-edit';
import { PatientDuplicatesPage } from './pages/patient-duplicates';
import { PlatformUsersPage } from './pages/platform-users';
import { OrgProductsPage } from './pages/org-products';
import { ProductConsentPage } from './pages/product-consent';
import { ProductCreatePage } from './pages/product-create';
import { ProductDetailPage } from './pages/product-detail';
import { ProductEditPage } from './pages/product-edit';
import { ProductsPage } from './pages/products';
import { QuestionSetEditPage } from './pages/question-set-edit';
import { QuestionSetNewPage } from './pages/question-set-new';
import { QuestionSetsListPage } from './pages/question-sets';
import { RoleCreatePage } from './pages/role-create';
import { RoleEditPage } from './pages/role-edit';
import { RolesPage } from './pages/roles';
import { SettingsPage } from './pages/settings';
import { SetupPage } from './pages/setup';
import { ReasonCodesPage } from './pages/reason-codes';
import { WorkflowDetailPage } from './pages/workflow-detail';
import { WorkflowEditPage } from './pages/workflow-edit';
import { WorkflowNewPage } from './pages/workflow-new';
import { NotificationsSubscriptionsPage } from './pages/notifications-subscriptions';
import { NotificationsTemplatesPage } from './pages/notifications-templates';
import { WorkflowsListPage } from './pages/workflows';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/setup/:token" element={<SetupPage />} />
      <Route
        path="*"
        element={
          <RequireSession>
            <AppShell>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/orgs" element={<OrgsListPage />} />
                <Route path="/orgs/new" element={<OrgEditPage />} />
                <Route path="/orgs/:orgId" element={<OrgDetailPage />} />
                {/* Legacy /edit URL redirects to the unified detail page. */}
                <Route
                  path="/orgs/:orgId/edit"
                  element={<Navigate to=".." replace relative="path" />}
                />
                <Route path="/orgs/:orgId/products" element={<OrgProductsPage />} />
                <Route path="/orgs/:orgId/reason-codes" element={<ReasonCodesPage />} />
                <Route
                  path="/orgs/:orgId/products/:productId/integration"
                  element={<IntegrationPage />}
                />
                <Route
                  path="/orgs/:orgId/products/:productId/consent"
                  element={<OrgConsentPage />}
                />
                <Route path="/admin-users" element={<AdminUsersListPage />} />
                <Route path="/admin-users/new" element={<AdminUserInvitePage />} />
                <Route path="/admin-users/:id/edit" element={<AdminUserEditPage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/patients" element={<PatientsPage />} />
                <Route path="/patients/:id" element={<PatientDetailPage />} />
                <Route path="/cases" element={<CasesListPage />} />
                <Route path="/cases/:id" element={<CaseDetailPage />} />
                <Route path="/cases/:id/requests" element={<CaseRequestsPage />} />
                <Route path="/roles" element={<RolesPage />} />
                <Route path="/roles/new" element={<RoleCreatePage />} />
                <Route path="/roles/:id/edit" element={<RoleEditPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/new" element={<ProductCreatePage />} />
                <Route path="/products/:id" element={<ProductDetailPage />} />
                <Route path="/products/:id/edit" element={<ProductEditPage />} />
                <Route path="/products/:id/consent" element={<ProductConsentPage />} />
                <Route path="/users" element={<PlatformUsersPage />} />
                <Route path="/users/duplicates" element={<PatientDuplicatesPage />} />
                <Route path="/users/new" element={<PlatformUserCreatePage />} />
                <Route path="/users/:id/edit" element={<PlatformUserEditPage />} />
                <Route path="/workflows" element={<WorkflowsListPage />} />
                <Route path="/workflows/new" element={<WorkflowNewPage />} />
                <Route path="/workflows/:id" element={<WorkflowDetailPage />} />
                <Route path="/workflows/:id/edit" element={<WorkflowEditPage />} />
                <Route path="/question-sets" element={<QuestionSetsListPage />} />
                <Route path="/question-sets/new" element={<QuestionSetNewPage />} />
                <Route path="/question-sets/:id" element={<QuestionSetEditPage />} />
                <Route path="/reason-codes" element={<ReasonCodesPage />} />
                <Route path="/patient-erasure" element={<PatientErasurePage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route
                  path="/notifications/subscriptions"
                  element={<NotificationsSubscriptionsPage />}
                />
                <Route path="/notifications/templates" element={<NotificationsTemplatesPage />} />
              </Routes>
            </AppShell>
          </RequireSession>
        }
      />
    </Routes>
  );
}
